export enum DemandCasesDataGridField {
  SEQUENCE_NUMBER = 'sequenceNumber',
  SUPPLIER = 'supplier',
  ADDED_BY = 'addedBy',
  STATUS = 'status',
  IS_RELEASABLE = 'isReleasable',
  TOTAL_VALUE = 'totalValue',
  DISCOUNT = 'discount',
  CONTACT_FIRST_NAME = 'firstName',
  CONTACT_LAST_NAME = 'lastName',
  CONTACT_EMAIL = 'email',
  ISSUES_OPEN_COUNT = 'issuesOpen',
  ISSUES_COMPLETED_COUNT = 'issuesCompleted',
  LATEST_COMMENT = 'latestComment',
}
